import { render, staticRenderFns } from "./LensDashboardView.vue?vue&type=template&id=3d0850c3&scoped=true"
import script from "./LensDashboardView.vue?vue&type=script&lang=js"
export * from "./LensDashboardView.vue?vue&type=script&lang=js"
import style0 from "./LensDashboardView.vue?vue&type=style&index=0&id=3d0850c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0850c3",
  null
  
)

export default component.exports